<form [formGroup]="entityRentalPropertyLicense" style="max-width: 100vh;">
  <div class="form-container">
    <div class="form-row">

      <div class="field-caption">Department of Business and Professional Regulation License Number</div>
      <mat-form-field class="mat-form-field-100" appearance="outline">
        <mat-label>DBPR license number</mat-label>
        <input matInput formControlName="departmentOfBusiness"
          >
        <mat-icon matSuffix
          matTooltip="Florida State Business License (FORM: #DBPR HR-7028) for further information contact the DBPR at 850-487-1395."
          class="my-icon" iconPositionEnd>info_outline</mat-icon>
        <mat-error
          >License
          number should not include spaces, leading zeros, or colons</mat-error>
      </mat-form-field>
    </div>

    <div class="form-row">
      <div class="form-col">
        <div>
          <mat-card appearance="outlined">
            <mat-card-content>
              <div class="row">
                Please provide one of these fields
              </div>
              <br />
              <div class="form-row">
                <div class="form-col">
                  <div class="field-caption">Florida State Department of Revenue Sales Tax Certificate Number</div>
                  <mat-form-field class="mat-form-field-95" appearance="outline">
                    <mat-label>Sales tax certificate number</mat-label>
                    <input matInput formControlName="taxCertificateNumber"
                       maxlength="15"
                      appTaxCertificateNumber>
                    <mat-error
                      *ngIf="this.entityRentalPropertyLicense.get('taxCertificateNumber')?.hasError('invalidTaxCertificateNumber') && (entityRentalPropertyLicense.get('taxCertificateNumber')?.touched )">The
                      certificate number format is 2 digits - 10 digits - 1 digit</mat-error>
                  </mat-form-field>
                </div>
              </div>
              <div class="form-row">
                <div class="form-col">
                  <div class="row align-item-center gap-10">
                    <mat-checkbox formControlName="stateCertificateHasBeenApplied" color="primary" class="primary">
                      State Certificate has been applied for
                      </mat-checkbox>
                      <mat-icon
                      matTooltip="Each rental property must be registered with the Florida Department of Revenue for state sales tax purposes. If you have not yet received your certificate number please indicate in the 'applied for' checkbox above. For further information contact the Florida Department of Revenue at 941-343-0201 or https://floridarevenue.com.."
                      too aria-hidden="false">info_outline
                    </mat-icon>
                  </div>
                </div>
              </div>
              <div class="form-row">
                <div class="form-col">
                  <div class="field-caption">If the business has not been registered, please state the reason why</div>
                  <mat-form-field class="mat-form-field-95" appearance="outline">
                    <mat-label>Reason not registered</mat-label>
                    <input matInput formControlName="reasonWhy"
                    >
                      <mat-error *ngIf="true">
                        If the property has not been registered, please state the reason why.
                      </mat-error>
                  </mat-form-field>
                </div>
              </div>

            </mat-card-content>

          </mat-card>

        </div>
      </div>
    </div>

    <div class="row first-row-footer" *ngIf="!this.hidePrimaryContactInfo">
      <div class="col-md-6 col-xs-12">

        <mat-form-field class="mat-form-field-95"
          appearance="outline" requiered>
          <mat-label style="font-size: 16px !important;">Primary contact first name</mat-label>
          <input matInput formControlName="primaryContactFirstName" placeholder="Primary contact first name" required>
          <mat-error>Primary contact first name is required</mat-error>
        </mat-form-field>
      </div>

      <div class="col-md-6 col-xs-12">

        <mat-form-field class="mat-form-field-100"
          appearance="outline" requiered>
          <mat-label style="font-size: 16px !important;">Primary contact last name</mat-label>
          <input matInput formControlName="primaryContactLastName" placeholder="Primary contact last name" required>
          <mat-error>Primary contact last name is required</mat-error>
        </mat-form-field>
      </div>
    </div>
    <div class="row" *ngIf="!this.hidePrimaryContactInfo">
      <div class="col-md-6 col-xs-12">

        <mat-form-field class="mat-form-field-95"
          appearance="outline" requiered>
          <mat-label style="font-size: 16px !important;">Primary contact email address</mat-label>
          <input matInput formControlName="primaryContactEmail" placeholder="Primary contact email address" required>
          <mat-error
            *ngIf="this.entityRentalPropertyLicense?.get('primaryContactEmail')?.errors?.['email'] && (entityRentalPropertyLicense?.get('primaryContactEmail')?.touched)">Primary
            contact email address is invalid</mat-error>

          <mat-error
            *ngIf="this.entityRentalPropertyLicense?.get('primaryContactEmail')?.errors?.['required'] && (entityRentalPropertyLicense?.get('primaryContactEmail')?.touched)">Primary
            contact email address is required</mat-error>

        </mat-form-field>
      </div>

      <div class="col-md-6 col-xs-12">

        <mat-form-field class="mat-form-field-100"
          appearance="outline" requiered>
          <mat-label style="font-size: 16px !important;">Primary contact phone number</mat-label>
          <input matInput appPhoneFormat formControlName="primaryContactPhoneNumber" placeholder="Primary contact phone number"
            required>
          <mat-error
            *ngIf="this.entityRentalPropertyLicense?.get('primaryContactPhoneNumber')?.errors?.['pattern'] && (entityRentalPropertyLicense?.get('primaryContactPhoneNumber')?.touched)">Primary
            contact phone number is invalid</mat-error>

          <mat-error
            *ngIf="this.entityRentalPropertyLicense?.get('primaryContactPhoneNumber')?.errors?.['required'] && (entityRentalPropertyLicense?.get('primaryContactPhoneNumber')?.touched)">Primary
            contact phone number is required</mat-error>

        </mat-form-field>
      </div>
    </div>
  </div>
</form>